import { render, staticRenderFns } from "./consultant-add.vue?vue&type=template&id=464dad7f&scoped=true"
import script from "./consultant-add.vue?vue&type=script&lang=js"
export * from "./consultant-add.vue?vue&type=script&lang=js"
import style0 from "./consultant-add.vue?vue&type=style&index=0&id=464dad7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464dad7f",
  null
  
)

export default component.exports